import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const TextInput = props => {
  const classes = useStyles();
  const {
    className = '',
    id,
    innerRef,
    InputProps,
    InputLabelProps,
    type = '',
    InputPropsClasses = {},
    readOnly = false,
    ...rest
  } = props;

  const inputStyle = type === 'password' ? classes.password : '';
  return (
    <TextField
      id={id}
      type={type}
      className={className}
      margin="normal"
      variant="outlined"
      InputProps={{
        classes: {
          root: clsx(classes.root, {
            [classes.readOnly]: readOnly
          }),
          input: clsx(classes.input, inputStyle),
          adornedEnd: classes.adornedEnd,
          inputAdornedStart: classes.inputAdornedStart,
          ...InputPropsClasses
        },
        ref: innerRef,
        readOnly,
        ...InputProps
      }}
      FormHelperTextProps={{
        classes: {
          root: classes.helperText
        }
      }}
      InputLabelProps={{
        ...InputLabelProps
      }}
      {...rest}
    />
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 58
  },
  input: {
    height: 'inherit',
    fontSize: 14
  },
  adornedEnd: {
    paddingRight: 0
  },
  helperText: {
    fontSize: 12,
    marginTop: 5
  },
  password: {
    font: 'large Verdana,sans-serif',
    fontSize: 17
  },
  inputAdornedStart: {
    paddingLeft: 14
  },
  readOnly: {
    cursor: 'default',
    userSelect: 'none',
    color: theme.palette.text.disabled
  }
}));

export default TextInput;
